export const topSeries = [
  { title: 'Flexi Light', slug: 'flexi-light' },
  { title: 'Arcus', slug: 'arcus' },
  { title: 'FollowMe', slug: 'followme' },
  { title: 'Nido', slug: 'nido' },
  { title: 'Melody Design', slug: 'melody-design' },
  { title: 'Flexi Lounge', slug: 'flexi-lounge' },
  { title: 'Lotus', slug: 'lotus' },
]
